import {call, put, takeEvery} from 'redux-saga/effects';
import LeasingCompaniesService from "../services/api/LeasingCompaniesService";
import * as types from "../constants/ActionTypes";
import {fetchLeasingCompaniesSuccess, fetchLeasingCompaniesFailure} from "../actions/leasingCompaniesActions";

function* fetchLeasingCompanies() {
    try {
        const leasingCompanies = yield call(LeasingCompaniesService.getLeasingCompanies);
        yield put(fetchLeasingCompaniesSuccess(leasingCompanies.body));
    } catch (error) {
        yield put(fetchLeasingCompaniesFailure(error));
    }
}

export function* watchFetchLeasingCompanies() {
    yield takeEvery(types.FETCH_LEASING_COMPANIES, fetchLeasingCompanies);
}
